import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Consulting from './components/Consulting';
import Approach from './components/Approach';
import Stats from './components/Stats';
import Training from './components/Training';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/CaseStudies';
import Founder from './components/Founder';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LogoPreview from './components/LogoPreview';
import PrivacyPolicy from './components/PrivacyPolicy';
import Terms from './components/Terms';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import AgentApp from './agent/AgentApp';

const Home = () => (
  <div className="bg-white text-slate-900 antialiased overflow-x-hidden">
    <Navbar />
    <main>
      <Hero />
      <Services />
      <Consulting />
      <Approach />
      <Stats />
      <Training />
      <WhyChooseUs />
      <Testimonials />
      <Founder />
      <FAQ />
      <CTA />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/logos" element={<LogoPreview />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/agent/*" element={<AgentApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
